import { DISCIPLINE_META, describeSlot, type Discipline } from '@bm/contracts';
import { LineupSlotBox, type AssignedPlayer } from './LineupSlotBox';

export interface DisciplineInstanceState {
  position: number;
  member1: AssignedPlayer | null;
  member2: AssignedPlayer | null;
}

/** Eine Disziplin (z. B. "Herrendoppel") mit all ihren Instanzen (1./2.
 * Herrendoppel) — leitet Doppel-vs-Einzel und die Instanzanzahl komplett aus
 * `DISCIPLINE_META` ab, keine Disziplin ist hier hart codiert. Ein neues
 * Mannschaftsformat braucht dafür nur eine neue Konfiguration in
 * lineup-rules.ts, keine Änderung an dieser Komponente. */
export function LineupDisciplineSection({
  discipline,
  instances,
  disabled,
  isDragActive,
  isValidDropTarget,
  onOpenDrawer,
  onRemove,
  onDrop,
}: {
  discipline: Discipline;
  instances: DisciplineInstanceState[];
  disabled: boolean;
  isDragActive: boolean;
  isValidDropTarget: (position: number, memberSlot: 1 | 2) => boolean;
  onOpenDrawer: (position: number, memberSlot: 1 | 2) => void;
  onRemove: (position: number, memberSlot: 1 | 2) => void;
  onDrop: (position: number, memberSlot: 1 | 2) => void;
}) {
  const meta = DISCIPLINE_META[discipline];
  return (
    <div className="space-y-1">
      <h3 className="text-sm font-semibold text-slate-700">{meta.label}</h3>
      <div className="space-y-1.5">
        {instances.map((inst) => (
          <div key={inst.position} className={meta.isDoubles ? 'rounded-lg border border-slate-100 bg-white p-1.5' : ''}>
            {meta.instances > 1 && (
              <div className={`text-xs font-medium text-slate-500 ${meta.isDoubles ? 'mb-1' : 'mb-0.5'}`}>
                {describeSlot(discipline, inst.position)}
              </div>
            )}
            <div className={meta.isDoubles ? 'grid grid-cols-1 gap-1.5 sm:grid-cols-2' : ''}>
              <LineupSlotBox
                discipline={discipline}
                memberSlot={1}
                player={inst.member1}
                disabled={disabled}
                isDragActive={isDragActive}
                isValidDropTarget={isValidDropTarget(inst.position, 1)}
                onOpenDrawer={() => onOpenDrawer(inst.position, 1)}
                onRemove={() => onRemove(inst.position, 1)}
                onDrop={() => onDrop(inst.position, 1)}
              />
              {meta.isDoubles && (
                <LineupSlotBox
                  discipline={discipline}
                  memberSlot={2}
                  player={inst.member2}
                  disabled={disabled}
                  isDragActive={isDragActive}
                  isValidDropTarget={isValidDropTarget(inst.position, 2)}
                  onOpenDrawer={() => onOpenDrawer(inst.position, 2)}
                  onRemove={() => onRemove(inst.position, 2)}
                  onDrop={() => onDrop(inst.position, 2)}
                />
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
